import React, { Fragment, useState } from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { Dialog } from '../../../legacy-design-system/modal'
import { BasicDialogBodyWithoutCancel } from '../../../legacy-design-system/modal/dialog'
import { ClipboardTextarea } from '../../../legacy-design-system/form-text/clipboard-textarea'
import { logSuccess } from '../../toaster'
import { drilldownHeaderCss } from '../../../legacy-design-system/text'

export interface VrApiExportDialogProps {
  isDialogOpen: boolean
  closeDialog: () => void
  titleId: string
  subtitleId?: string
  sections: ApiSectionProp[]
  e2eTestId?: string
}

interface ApiSectionProp {
  titleId?: string
  curlCommand: string
  sectionTestId?: string
}

const apiLink = 'https://api.contrastsecurity.com/'

export const useVrApiExportDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const openDialog = () => setIsDialogOpen(true)
  const closeDialog = () => setIsDialogOpen(false)
  return {
    dialogProps: {
      isDialogOpen,
      closeDialog
    },
    openDialog
  }
}

export function VrApiExportDialog({
  isDialogOpen,
  closeDialog,
  titleId,
  subtitleId,
  sections,
  e2eTestId
}: VrApiExportDialogProps) {
  const intl = useIntl()

  return (
    <Dialog
      isOpen={isDialogOpen}
      renderTitle={() => intl.formatMessage({ id: titleId })}
      onCancel={closeDialog}
      size="large"
      testId={e2eTestId}
    >
      <BasicDialogBodyWithoutCancel
        body={
          <>
            <Intro subtitleId={subtitleId} />
            {sections.map(
              (
                { titleId: sectionTitleId, curlCommand, sectionTestId },
                sectionIndex
              ) => (
                <Fragment key={sectionIndex}>
                  <section>
                    {sections.length > 1 && sectionTitleId ? (
                      <div
                        className={cx(
                          drilldownHeaderCss,
                          css`
                            margin-bottom: 5px;
                          `
                        )}
                      >
                        {intl.formatMessage({ id: sectionTitleId })}
                      </div>
                    ) : undefined}
                    <ClipboardTextarea
                      e2eTestId={`${sectionTestId}-textarea`}
                      labelId="detail_apiSampleRequest"
                      value={curlCommand}
                      classNameTextArea={css`
                        min-height: 150px;
                      `}
                      onCopy={() =>
                        logSuccess(
                          intl.formatMessage({
                            id: 'detail_apiRequestCopied'
                          })
                        )
                      }
                    />
                  </section>
                  {sectionIndex < sections.length - 1 ? <br /> : undefined}
                </Fragment>
              )
            )}
          </>
        }
        onConfirm={closeDialog}
        confirmButtonText={intl.formatMessage({ id: 'action_close' })}
      />
    </Dialog>
  )
}

function Intro({ subtitleId }: { subtitleId?: string }) {
  const intl = useIntl()

  return (
    <>
      <p>
        {intl.formatMessage({ id: 'detail_apiUseRecommendation' })}
        <a
          href={apiLink}
          target="_blank"
          className={css`
            margin-left: 0.2em;
          `}
        >
          {intl.formatMessage({ id: 'action_learnMore' })}
        </a>
      </p>
      <p>{intl.formatMessage({ id: subtitleId || 'detail_apiAccessOne' })}</p>
      <br />
    </>
  )
}
